import { Drawer } from '../shared/Drawer';
import { QuizQuestionStep } from './QuizQuestionStep';
import { QuizResult } from './QuizResult';
import { QuizResultFooter } from './QuizResultFooter';
import { useSkinQuiz } from './useSkinQuiz';
import { useOverlayActions } from '../../contexts/StoreContext';
import { founder, salon } from '../../data/content';
import { shopLabels } from '../../data/shopLabels';
import { btnPrimary } from '../../ui/styles';

/**
 * Huidadvies in één minuut: vier vragen, dan een protocol. Bij de uitslag staat de hoofdknop
 * vast onderaan de lade; klein beginnen, de salon en "mail het me" staan in de uitslag zelf.
 */
export function SkinQuiz() {
  const q = useSkinQuiz();
  const {
    openBooking
  } = useOverlayActions();
  const showResult = !q.question && q.result && q.totals;
  return <Drawer open={q.open} onClose={q.close} title="Huidadvies in 1 minuut" footer={showResult && q.result && q.totals ? <QuizResultFooter result={q.result} totals={q.totals} onClose={q.close} data-id="element-8235" data-mp="60gwqtzrrfl6" /> : undefined} data-id="element-8234" data-mp="axz2ycmejgph">
      {q.question ? <QuizQuestionStep question={q.question} step={q.step} total={q.total} onAnswer={q.answer} onBack={q.back} data-id="element-8236" data-mp="2aa0dct32x9ch" /> : !q.result || !q.totals ?
    // Geen protocollen in de catalogus: de quiz eindigde voorheen in een lege lade.
    <div className="text-center" data-id="element-8237" data-mp="2p5psc79ukm7p">
          <h3 className="font-display text-2xl font-light text-ink" data-id="element-8238" data-mp="2p6rdj4kkup35">Dank je voor je antwoorden</h3>
          <p className="mt-3 text-[15px] leading-relaxed text-muted" data-id="element-8239" data-mp="2t68ilww3dk7s">
            Er staat nu geen protocol online dat ik je kan aanraden. Stuur me een appje, dan kijk ik persoonlijk mee.
          </p>
          <a href={salon.whatsapp} target="_blank" rel="noreferrer" className={`${btnPrimary} mt-6`} data-id="element-8240" data-mp="32x3592d92ltr">
            App {founder.firstName}
            <span className="sr-only" data-id="element-8241" data-mp="3cur0ruiojxcz">{shopLabels.viaWhatsApp}</span>
          </a>
          <button type="button" onClick={q.reset} className="mt-3 block w-full px-2 py-2 text-[14px] text-muted transition-colors duration-150 ease-soft hover:text-ink" data-id="element-8242" data-mp="3csxu4f82hd4z">
            Opnieuw doen
          </button>
        </div> : <QuizResult result={q.result} totals={q.totals} gift={q.gift} starter={q.starter} treatment={q.treatment} answers={q.answers} round={q.round} onClose={q.close} onCloseKeep={q.closeKeep} onRestart={q.reset} onBookTreatment={slug => {
      // De antwoorden blijven staan: wie terugkomt, ziet het advies nog.
      q.closeKeep();
      openBooking(slug);
    }} data-id="element-8243" data-mp="1ctaror80vq49" />}
    </Drawer>;
}